function getPreviewMapLink({ mapId }: { mapId: string }) {
  return `/map/preview/${mapId}`
}

export { getPreviewMapLink }
